<style lang="scss">
    @import "../../../sass/layout/tables"
</style>

<template>
    <div class="reports-history mt-5">
        <a id="reports-history"></a>
        <div class="card card-primary p-0">
            <div class="card-header m-0">
                <div class="text-medium-blue m-0">Last 10 Reports</div>
            </div>
            <div class="card-body p-0 table-template">
                <table v-if="auth.is('site-admin')" class="table">
                    <thead>
                        <tr>
                            <th v-for="field in fieldsState">{{ field.label }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in reportsCopy">
                            <td>
                                <strong>
                                    <a :href="$basePath+'/reports/' + item.id">
                                        {{ item.type.name }}
                                        <small><span class="fa fa-chevron-right"></span></small>
                                    </a>
                                </strong>
                            </td>
                            <td>{{ formatDate(item.created_at) }}</td>
                            <td>{{ (item.program) ? item.program.name : 'All Programs' }}</td>
                            <td>{{ (item.starts_at && item.ends_at) ? formatDate(item.starts_at) + ' - ' + formatDate(item.ends_at) : 'All History' }}</td>
                            <td>{{ (item.state_id !== null) ? item.state.abbreviation : 'All States' }}</td>
                            <td>
                                <button type="button" class="btn btn-default bg-white" @click="deleteReport(item, index)">
                                    <span class="fa fa-times"></span>
                                </button>
                            </td>
                        </tr>
                    </tbody>

                </table>

                <table v-if="auth.is('partner-user')" class="table">
                    <thead>
                        <tr>
                            <th v-for="field in fieldsCounty">{{ field.label }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in reportsCopy">
                            <td>
                                <strong>
                                    <a :href="$basePath+'/reports/' + item.id">
                                        {{ item.type.name }}
                                        <small><span class="fa fa-chevron-right"></span></small>
                                    </a>
                                </strong>
                            </td>
                            <td>{{ formatDate(item.created_at) }}</td>
                            <td>{{ (item.program) ? item.program.name : 'All Programs' }}</td>
                            <td>{{ (item.starts_at && item.ends_at) ? formatDate(item.starts_at) + ' - ' + formatDate(item.ends_at) : 'All History' }}</td>
                            <td>{{ (item.county_id !== null) ? item.county.name : 'All Counties' }}</td>
                            <td>
                                <a class="delete-report" @click="deleteReport(item, index)">
                                    <span class="fa fa-times"></span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table v-if="!auth.is('site-admin') && !auth.is('partner-user')" class="table">
                    <thead>
                        <tr>
                            <th v-for="field in fieldsNeither">{{ field.label }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in reportsCopy">
                            <td>
                                <strong>
                                    <a :href="$basePath+'/reports/' + item.id">
                                        {{ item.type.name }}
                                        <small><span class="fa fa-chevron-right"></span></small>
                                    </a>
                                </strong>
                            </td>
                            <td>{{ formatDate(item.created_at) }}</td>
                            <td>{{ (item.program) ? item.program.name : 'All Programs' }}</td>
                            <td>{{ (item.starts_at && item.ends_at) ? formatDate(item.starts_at) + ' - ' + formatDate(item.ends_at) : 'All History' }}</td>
                            <td>
                                <a class="delete-report" @click="deleteReport(item, index)">
                                    <span class="fa fa-times"></span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        components: {},
        props: {
            reports: {
                required: true,
                type: Array
            }
        },

        data() {
            return {
                fieldsCounty: [
                    { key: 'type', label: 'Type of Report'},
                    { key: 'created', label: 'Report Created'},
                    { key: 'programs', label: 'Programs Included'},
                    { key: 'range', label: 'Date Range'},
                    { key: 'county', label: 'County'},
                    { key: 'delete', label: 'Delete'}
                ],
                fieldsState: [
                    { key: 'type', label: 'Type of Report'},
                    { key: 'created', label: 'Report Created'},
                    { key: 'programs', label: 'Programs Included'},
                    { key: 'range', label: 'Date Range'},
                    { key: 'state', label: 'State'},
                    { key: 'delete', label: 'Delete'}
                ],
                fieldsNeither: [
                    { key: 'type', label: 'Type of Report'},
                    { key: 'created', label: 'Report Created'},
                    { key: 'programs', label: 'Programs Included'},
                    { key: 'range', label: 'Date Range'},
                    { key: 'delete', label: 'Delete'}
                ],
                reportsCopy: [],
                auth: window.Auth
            }
        },
        methods: {
            formatDate(date, format = 'MM/DD/YY') {
                return moment(date).format(format);
            },
            deleteReport(report, index) {
                if (confirm('Are you sure you want to delete this report?')) {
                    axios.delete('/reports/'+report.id)
                        .then((response) => {
                            this.reportsCopy.splice(index, 1);
                        })
                        .catch((error) => {
                            alert('there was a problem deleting the report.');
                        })
                }
            }
        },
        mounted() {
            this.reportsCopy = JSON.parse(JSON.stringify(this.reports));
        }
    
}
</script>